import { ActionBase } from '../actions/action-base';
//
// Library
//
import * as Library from '../../../lib/core/library/index';
//
// Actions
//
import {
  MENU_ACTION,
  MenuActionOnLoad,
  MenuActionSetActive,
  MenuActionSetToken,
  MenuActionEnableDetaiMenuItems,
  MenuActionEnableAccessories,
  MenuActionFeatureDisableProtectionProducts,
  MenuActionEnableProtectionProducts,
  MenuActionFeatureDisableAccessories,
  MenuActionFeatureDisableApplyForCredit,
  MenuActionEnableApplyForCredit,
  MenuActionFeatureDisableLocalSpecials,
  MenuActionEnableLocalSpecial
} from '../actions/menu.action';
//
// Reducer Model
//
import { Action } from '../../../lib/core/common/action';
//
// Reducer Interface
//
export interface IMenuState {
  items: Action[];
  token: string;
}

//
// Initial State
//
export const IMENU_INITIAL_STATE: IMenuState = {
  token: undefined,
  items: [
    new Action({
      label: 'Home',
      name: '',
      active: true
    }),
    new Action({
      label: 'Detail',
      name: 'detail',
      hidden: true
    }),
    new Action({
      label: 'Accessories',
      name: 'accessories',
      hidden: true
    }),
    new Action({
      label: 'Protection Products',
      name: 'protectionproducts',
      hidden: true
    }),
    new Action({
      label: 'Apply For Credit',
      name: 'applyforcredit',
      hidden: true
    }),
    new Action({
      label: 'Local Special',
      name: 'specials',
      hidden: true
    })
  ]
};

/* tslint:disable:no-switch-case-fall-through */
export function MenuStateReducer(
  state = IMENU_INITIAL_STATE,
  action: ActionBase
): IMenuState {
  //
  // Switch on Action Type
  //
  switch (action.type) {
    case MENU_ACTION.LOAD:
      return _onLoad(state, action as MenuActionOnLoad);
    case MENU_ACTION.SET_ACTIVE:
      return _onSetActive(state, action as MenuActionSetActive);
    case MENU_ACTION.SET_TOKEN:
      return _onSetToken(state, action as MenuActionSetToken);
    case MENU_ACTION.ENABLE_DETAIL_MENU_ITEMS:
      return _EnableDetailMenuItems(state, action as MenuActionEnableDetaiMenuItems);
    case MENU_ACTION.ENABLE_ACCESSORIES:
      return _EnableAccessories(state, action as MenuActionEnableAccessories);
      case MENU_ACTION.ENABLE_PROTECTIONPRODUCTS:
      return _EnableProtectionProducts(state, action as MenuActionEnableProtectionProducts);
    case MENU_ACTION.ENABLE_LOCAL_SPECIALS:
      return _EnableLocalSpecial(state, action as MenuActionEnableLocalSpecial);
    case MENU_ACTION.ENABLE_APPLYFORCREDIT:
      return _EnableApplyForCredit(state, action as MenuActionEnableApplyForCredit);
    case MENU_ACTION.FEATURE_DISABLE_APPLYFORCREDIT:
      return _MenuFeatureDisabled(state, 'Apply For Credit', action as MenuActionFeatureDisableApplyForCredit);
    case MENU_ACTION.FEATURE_DISABLE_PROTECTIONPRODUCTS:
      return _MenuFeatureDisabled(state, 'Protection Products', action as MenuActionFeatureDisableProtectionProducts);
    case MENU_ACTION.FEATURE_DISABLE_ACCESSORIES:
      return _MenuFeatureDisabled(state, 'Accessories', action as MenuActionFeatureDisableAccessories);
    case MENU_ACTION.FEATURE_DISABLE_LOCAL_SPECIALS:
      return _MenuFeatureDisabled(state, 'Local Special', action as MenuActionFeatureDisableLocalSpecials);
    default: {
      return state;
    }
  }
}
//
// General Functions
//
export function LoadMenu(state: IMenuState) {
  return state;
}

//
// _onLoad()
//
function _onLoad(state: IMenuState, action: MenuActionOnLoad): IMenuState {
  return state;
}

//
// _onSetActive()
//
function _onSetActive(state: IMenuState, action: MenuActionSetActive): IMenuState {
  const item = action.payload;
  const _state = Object.assign({}, state);

  _state.items.map((s) => {
    s.active = (s.label === item.label);
    return s;
  });

  //
  // Do Work...
  //
  return _state;
}

//
// _onSetToken()
//
function _onSetToken(state: IMenuState, action: MenuActionSetToken): IMenuState {
  const token = action.payload;
  const _state = Object.assign({}, state);
  //
  // Set the Token
  //
  _state.token = token;

  //
  // Do Work...
  //
  return _state;
}
//
// _EnableAccessories()
//
function _EnableAccessories(state: IMenuState, action: MenuActionEnableAccessories): IMenuState {
  const _state = Object.assign({}, state);
  //
  // Disable/Enabled Accessories
  //
  _state.items.forEach((menu) => {
    if (menu.label === 'Accessories') {
      menu.hidden = !menu.isFeatureDisabled ? !action.payload : true;
      console.log(`Accessories Menu: ${action.payload ? 'Enabled' : 'Disabled'}`);
    } else if (menu.label === 'Home') {
      menu.hidden = Library.isUndefined(_state.token);
    }
  });
  //
  // Do Work...
  //
  return _state;
}

//_EnableApplyForCredit

function _EnableApplyForCredit(state: IMenuState, action: MenuActionEnableApplyForCredit): IMenuState {
  const _state = Object.assign({}, state);
  //
  // Disable/Enabled applyfor credit
  //
  _state.items.forEach((menu) => {
    if (menu.label === 'Apply For Credit') {
      menu.hidden = !menu.isFeatureDisabled ? !action.payload : true;
      console.log(`applyforcredit Menu: ${action.payload ? 'Enabled' : 'Disabled'}`);
    } else if (menu.label === 'Home') {
      menu.hidden = Library.isUndefined(_state.token);
    }
  });
  //
  // Do Work...
  //
  return _state;
}
//
// _EnableProtectionProducts()
//
function _EnableProtectionProducts(state: IMenuState, action: MenuActionEnableProtectionProducts): IMenuState {
  const _state = Object.assign({}, state);
  //
  // Disable/Enabled Accessories
  //
  _state.items.forEach((menu) => {
    if (menu.label === 'Protection Products') {
      menu.hidden = !menu.isFeatureDisabled ? !action.payload : true;
      console.log(`Protection Products Menu: ${action.payload ? 'Enabled' : 'Disabled'}`);
    } else if (menu.label === 'Home') {
      menu.hidden = Library.isUndefined(_state.token);
    }
  });
  //
  // Do Work...
  //
  return _state;
}
//
// _EnableLocalSpecial()
//
function _EnableLocalSpecial(state: IMenuState, action: MenuActionEnableLocalSpecial): IMenuState {
  const _state = Object.assign({}, state);
  //
  // Disable/Enabled Accessories
  //
  _state.items.forEach((menu) => {
    if (menu.label === 'Local Special') {
      menu.hidden = !menu.isFeatureDisabled ? !action.payload : true;
      console.log(`Local Special Menu: ${action.payload ? 'Enabled' : 'Disabled'}`);
    } else if (menu.label === 'Home') {
      menu.hidden = Library.isUndefined(_state.token);
    }
  });
  //
  // Do Work...
  //
  return _state;
}
//
// _EnableDetailMenuItems()
//
function _EnableDetailMenuItems(state: IMenuState, action: MenuActionEnableDetaiMenuItems): IMenuState {
  const hidden = action.payload['hidden'];
  // const routerLink = action.payload['routerLink'];
  const _state = Object.assign({}, state);

  _state.items.map((s) => {
    // s.active = (s.label === routerLink);
    if (s.label === 'Detail') {
      s.hidden = !s.isFeatureDisabled ? hidden : true;
    } else if (s.label === 'Home') {
      s.hidden = Library.isUndefined(_state.token);
    }
    return s;
  });

  //
  // Do Work...
  //
  return _state;
}

//
// _MenuFeatureDisabled()
//
function _MenuFeatureDisabled(state: IMenuState, menuLabel: string,
  action: MenuActionFeatureDisableAccessories | MenuActionFeatureDisableLocalSpecials): IMenuState {
  const _state = Object.assign({}, state);
  //
  // Disable/Enabled Accessories
  //
  _state.items.filter(menu => menu.label === menuLabel).map(menu => {
    menu.isFeatureDisabled = action.payload;
  });
  //
  // Do Work...
  //
  return _state;
}
